import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldOff } from "lucide-react";
import { API, useAuth } from "../App";

// Shown when production has no BAA-covered AI route: AI/voice are paused so PHI never leaves.
export const AiPausedBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user?.id) return;
    axios.get(`${API}/hipaa-guardrails/ai-status`).then((r) => setStatus(r.data)).catch(() => {});
  }, [user?.id]);

  if (!status || (status.ai_available && status.voice_available)) return null;
  return (
    <div data-testid="ai-paused-banner" className="w-full bg-rose-50 dark:bg-rose-950/40 border-b border-rose-200 dark:border-rose-900/50 text-rose-900 dark:text-rose-200">
      <div className="max-w-7xl mx-auto flex items-center gap-2 px-4 py-1.5 text-xs">
        <ShieldOff className="w-3.5 h-3.5 flex-shrink-0" />
        <span className="flex-1 leading-snug" data-testid="ai-paused-banner-message">
          <strong className="font-semibold">{status.ai_available ? "Voice transcription is paused." : "AI features are paused."}</strong>{" "}
          {status.message}
        </span>
      </div>
    </div>
  );
};

export default AiPausedBanner;
